import { ReactNode } from "react";

export interface SectionSidebarProps {
  ariaLabel: string;
  children: ReactNode;
}

export const SectionSidebar = ({ ariaLabel, children }: SectionSidebarProps) => {
  return (
    <nav
      aria-label={ariaLabel}
      className="flex h-full w-56 shrink-0 flex-col border-r border-border bg-sidebar"
    >
      {children}
    </nav>
  );
};
